export const regionModel = {
    label: 'Région',
    tableName: 'regions',
    properties: [
        {
            label: 'Nom',
            id: 'name',
            type: 'text',
            example: 'Analamanga', // Exemple : Analamanga, Diana, Atsinanana, etc.
            required: true
        }
    ]
}
